module.exports = __webpack_public_path__ + "img/107040.58fb45c2.png";